<div class="textRecordsContainer" style="display: none;">
    <!-- <i *ngIf="bodySpinner" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
    <span class="sr-only">Loading...</span> -->
    <div class="loader" *ngIf="bodySpinner"></div>
    <div class="header hdr">
         <div class="row" id="emailTableSearch">
                <div class="col-3">
        <h5><span class="animateH5">Client Contract Repository</span></h5>
        </div>
        <div class="col px-0">
            <span class="d-flex justify-content-end align-items-center">
                <span style="float: right; padding-right: 3px;margin-right:10px;" (click)="toggleBot()"><i style="font-size:1.5rem;" class="bi bi-robot"></i></span>
                
                  <span class="search-wrapper">
                     <span class="icon"><i class="fa-solid fa-magnifying-glass"></i></span>     <input type="text" [(ngModel)]="searchText" 
                    autocomplete="off"  placeholder="Search"
                    class="form-control audioTableSearchInput" name="searchInput" id="searchInput">
                  </span>   
                <button class="btn btn-primary audioTableSearchBtn me-2"><i class="bi bi-cloud-upload-fill"></i>&nbsp; Upload</button>
            </span>
            <!-- <div class="row mt-2">
            <div class="col-4"> <button class="btn btn-primary tab-button" [ngClass]="{'active':tabSelect=='chat'}" (click)="selectTab('chat')"> Negotation Board (chat with client)</button></div>
            <div class="col-4"><button class="btn btn-primary tab-button" [ngClass]="{'active':tabSelect=='email'}" (click)="selectTab('email')"> Negogation Via Email</button></div>
            </div> -->
       </div>
    </div>
    </div>
     <div class="container-fluid">
            <div class="position-relative w-100 mt-3"> 
                <div class="aibot-container" [ngClass]="{'bot-active':botEnabled}">
            
                <div class="aibotsection">
                    <div class="botwrapper">
                        <div class="botinput">
                            <textarea   placeholder="Ask anything"></textarea>
                            <div class="tools">
                                <span><i class="bi bi-send"></i></span>
                            </div>
                        </div>
                    </div>
                    <div class="bot-history-data">

                    </div>
                </div>
                <div class="document-list">
                    <div class="header w-100"><span style="float: right; padding-right: 3px;" (click)="toggleBot()"><i style="font-size:1rem;" class="bi bi-arrows-fullscreen"></i></span><label>Documents</label></div>
                    <div class="documents">
                        @if(repositoryList.length > 0){
                            <ul>
                                <ng-container *ngFor="let item of repositoryList; let idx = index, let e = even">
                                  
                                        <li><label class="custom-checkbox">
    <input type="checkbox" id="myCheckbox_{{idx}}" name="myCheckbox">
    <span class="checkmark"></span>
    {{item?.company_name}}
    </label></li>
    </ng-container>
                                    
                            </ul>  
                        }              
                    </div> 
                    </div>
                </div>
            </div>
        <div class="row"  *ngIf="!botEnabled">
            <div class="doc-list" [hidden]="expandEnabled">
                <div id="name-list">
                    <ul>
                        <ng-container  *ngFor="let items of contractList; let i=index">
                        <li [ngClass]="{'active':i==0}">
                            <span class="icon"><i class="bi bi-folder"></i></span>
                           <label> {{items?.contract_type}}</label>
                        </li>
                        </ng-container>
                    </ul>
                </div>

            </div>

            <div class="doc-data-list" [ngClass]="{'fullScreen':expandEnabled}">
                 <div class="table-responsive">
                <div class="card tblCrd"> 
                    <table class="table text-center">
                        <thead class="tblHead">
                            <tr>
                                 <th><span class="icon" (click)="expandPanel()"><i class="bi bi-arrows-fullscreen"></i></span></th>
                                <th>Client Name</th>
                                <th>Contract type</th>
                                <th>Effective Date</th>
                                <th>Termination Period</th>
                                <th>Termination Date</th>
                                <th>Termination Notice Period</th>
                                <th>Obiligation</th>
                                <th>Status</th>
                                <th>Summary</th>
                                <th>Version</th>
                                <th>Document</th>
                                <th>Assigned</th>
                               <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of repositoryList | filter:searchText:'status'">
                                <td></td>
                                <td class="text-start">{{data?.company_name}}</td>
                                <td>{{data?.contract_type}}</td>
                                <td>{{data?.efftectdate}}</td>
                                <td>{{data?.terminateperiod}}</td>
                                <td>{{data?.terminatedate}}</td>
                               
                                <td>{{data?.terminatenoticeperiod}}</td>
                                <td><span data-bs-toggle="modal"
                                    data-bs-target="#ObiligationModal" ><i class="bi bi-eye"></i></span></td>
                                <td>{{data?.status}}</td>
                                <td><span><i class="bi bi-eye"></i></span></td>
                                <td class="versionTd text-center">
                                             <span class="score-progress">
                                        
                                            <span class="categoryPara"> {{data?.version}}</span>
                                            
                                            <i class="fa fa-eye" aria-hidden="true" tooltip="View Version"
                                                 data-bs-toggle="modal" data-bs-target="#versionModal"
                                                ></i> 
                                       
                                            
                                        </span>
                                </td>
                                <td><span class="icon"><i class="bi bi-file-earmark-check"></i></span></td>
                                <td>{{data?.assigned}}</td>
                                <td><span class="icon"><i class="bi bi-pencil-square"></i></span></td>
                              
                            </tr>
                    </tbody>
                </table>
                </div>
                </div>            
            </div>
        </div>
     </div>
    </div>
        
         <!-- Email  Modal Window -->
      <div class="modal fade" id="ObiligationModal" tabindex="-1" aria-labelledby="ObiligationModal"
      aria-hidden="true">
      <div class="modal-dialog modal-xl"  >
          <div class="modal-content">
              <div class="modal-header">
                  <h4 class="modal-title" id="emailEscalateModalLabel">Obiligation</h4>
                  <span>
                 
                  <i class="fa-solid fa-xmark exitIcon " data-bs-dismiss="modal"
                      aria-label="Close"></i>
                 </span>
              </div>
              <div class="modal-body">
                
            

                    <div class="email-summary">
                      <div _ngcontent-ng-c795072520="" class="answer-content"><div class="response-container fallback-content"><p class="formatted-paragraph">The <b>obligation</b>s written in this Non-Disclosure Agreement (<b>NDA</b>) include:</p>
<ol class="formatted-list ordered-list">
<li class="list-item">
<p class="formatted-paragraph">Confidentiality: The Recipient agrees to keep confidential all information disclosed by the Discloser, which is designated as "confidential," "proprietary," or similar designations. This includes any information obtained directly or indirectly through inspection, review, or analysis of the Disclosed Materials.</p>
</li>
<li class="list-item">
<p class="formatted-paragraph">Use Restrictions: The Recipient agrees not to use the Disclosing Party's Confidential Information for any purpose other than the intended purpose described in the agreement.</p>
</li>
<li class="list-item">
<p class="formatted-paragraph">Exclusions from Confidentiality and Use Restrictions: The <b>obligation</b>s of confidentiality and non-use do not apply to information that was:</p>
</li>
<li class="list-item">Already known by the Recipient before disclosure by the Discloser</li>
<li class="list-item">Became publicly known through no breach of this agreement by the Recipient</li>
<li class="list-item">Independently developed by the Recipient without use or reference to the Discloser's Confidential Information</li>
<li class="list-item">
<p class="formatted-paragraph">Communicated to the Recipient by a third party not under <b>obligation</b> of confidentiality to the Discloser</p>
</li>
<li class="list-item">
<p class="formatted-paragraph">Return of Materials: Upon request, the Recipient agrees to return all materials containing the Disclosing Party's Confidential Information or destroy them if requested.</p>
</li>
<li class="list-item">
<p class="formatted-paragraph">Notice and Remedies: The Recipient must immediately notify the Discloser of any unauthorized use or disclosure of the Disclosing Party's Confidential Information. The Discloser has the right to seek legal remedies for any breach of this agreement.</p>
</li>
<li class="list-item">
<p class="formatted-paragraph">Survival: These <b>obligation</b>s will survive the termination or expiration of the agreement.</p>
</li>
</ol></div></div>
                    </div>
                
                    
                </div>
          </div>
      </div>
  </div>